import Request from '../../../../src/core/gd/data/request'
import {SystemStatus} from "../const/system-status"
import {ProjectSystemType} from "../../model2/project/types"

// const debug = "ApiUDS"
const debug = false

export default class ApiUDS {

    static getProjectsData(params: {
        templateIds?    : ID[],                 // optional
        projectIds?     : ID[],		            // optional
        ownerUserIds?   : ID[],			        // optional
        crmAccountIds?  : ID[],                 // optional is null or empty filter will not apply
        systemStatuses? : SystemStatus[], 	    // optional by default select all statuses
        systemTypes?    : ProjectSystemType[],  // optional, by default ALL_SYSTEM_TYPES accept view and workspace
        isDeleted?      : boolean, 	            // if null - filter will not apply, false by default
        isTemplate?     : boolean, 		        // if null - filter will not apply, false by default
        hasCRMAccount?  : boolean,
    }) {

        debug && console.log(debug, 'getProjectsData', params)

        return new Request(this,'POST','uds/projects', params)
    }

    static getProjectsUsers(projectIds: ID[]) {
        return new Request(this,'POST','uds/project-users', {projectIds})
    }

    static getProjectsUsersRecursively(projectIds: ID[]) {
        return new Request(this,'POST','uds/project-users', {
            projectIds          : projectIds,
            includeSubfolders   : true
        })
    }

    static getTasksProjectsUsers(taskIds: ID[]) {
        return new Request(this,'POST','uds/task-users', {taskIds})
    }

    static getTasksProjectsUsersRecursively(taskIds: ID[]) {
        return new Request(this,'POST','uds/task-users', {
            taskIds         : taskIds,
            includeSubtasks : true
        })
    }
}
